import http from '../config'
import { ENV_URL_PREFIX } from '@/config/env.js'
const user = {
  remarkEnum(params) {
    return http({
      url: 'user/remarkEnum',
      params
    })
  },
  bodyData(data) {
    return http({
      url: 'user/bodyData',
      data,
      method: 'post'
    })
  },
  bloodGlucoses(data) {
    return http({
      url: 'user/bloodGlucoses',
      data,
      method: 'post'
    })
  },
  bloodGlucose(data) {
    return http({
      url: 'user/bloodGlucose',
      data,
      method: 'post'
    })
  },
  bloodPressure(data) {
    return http({
      url: 'user/bloodPressure',
      data,
      method: 'post'
    })
  },
  history({ data, id }) {
    const url = id ? `user/history/${id}` : 'user/family'
    return http({
      url,
      method: 'post',
      data
    })
  },
  family({ method = 'get', params = {}, data = {}, id } = {}) {
    const url = id ? `user/family/${id}` : 'user/family'
    return http({
      url,
      method,
      params,
      data
    })
  },
  // 常用体检人
  medical_examiners({ method = 'get', params = {}, data = {}, id } = {}) {
    const url = id ? `user/medical_examiners/${id}` : 'user/medical_examiners'
    return http({
      url,
      params,
      data,
      method
    })
  },
  // 地址列表，新增，修改，删除
  address({ params = {}, data = {}, id, method = 'get' } = {}) {
    const url = id ? `address/shipping_addresses/${id}` : 'address/shipping_addresses'
    return http({
      url,
      params,
      data,
      method
    })
  },

  user_info_v2() {
    return http({
      url: 'user/user_info_v2'
    })
  },
  bind(data) {
    // const prefix = 'auth/api/'
    return http({
      url: 'cas/service/bind',
      data,
      method: 'post'
    })
  },
  // bind(data) {
  //   const prefix = 'auth/api/'
  //   return http({
  //     prefix,
  //     url: 'user/bind',
  //     data,
  //     method: 'post'
  //   })
  // },
  collects(params) {
    return http({
      url: 'user/collects',
      params
    })
  },
  collectSet(data) {
    return http({
      url: 'user/collects/set',
      method: 'post',
      data
    })
  },
  collectUnset(data) {
    return http({
      url: 'user/collects/unset',
      method: 'post',
      data
    })
  },
  upset(data) {
    return http({
      url: 'user/info/upset',
      method: 'post',
      data
    })
  },
  info({ params = {}, withoutLogin }) {
    return http({
      url: 'user/info',
      params,
      withoutLogin
    })
  },
  likeSet(data) {
    return http({
      url: 'user/likes/set',
      method: 'post',
      data
    })
  },
  likeUnset(data) {
    return http({
      url: 'user/likes/unset',
      method: 'post',
      data
    })
  },

  getOrderInfo({ withoutLogin = false }) {
    return http({
      url: 'user/order_info',
      withoutLogin
    })
  },
  getHealthInfo({ withoutLogin = false }) {
    return http({
      url: 'user/health_info',
      withoutLogin
    })
  },
  orderList(params) {
    return http({
      url: 'user/order/list',
      params
    })
  },

  orderDetail(params) {
    return http({
      url: 'user/order/detail',
      params
    })
  },

  orderCancel(data) {
    return http({
      url: 'user/order/cancel',
      method: 'post',
      data
    })
  },

  userDevices() {
    return http({
      url: 'user/userDevices'
    })
  },
  userDeviceBind(data) {
    return http({
      url: 'user/userDevice/bind',
      method: 'post',
      data
    })
  },
  userDevicesDetail(params) {
    return http({
      url: 'user/userDevices/detail',
      params
    })
  },
  userDeviceUnBind(data) {
    return http({
      url: 'user/userDevice/unBind',
      method: 'post',
      data
    })
  },
  familyMeasures(params) {
    return http({
      url: 'user/familyMeasures',
      params
    })
  },
  familyMeasuresPost(params) {
    return http({
      url: 'user/familyMeasures',
      method: 'post',
      params
    })
  },
  familyMeasuresDelete(id, device_type) {
    // console.log(device_type)
    let url
    if (+device_type === 1) {
      url = `user/familyMeasures/${id}`
    } else if (+device_type === 2) {
      url = `user/familyTemperatures/${id}`
    } else if (+device_type === 3) {
      url = `user/familyBodyFats/${id}`
    } else if (+device_type === 5) {
      url = `user/familyHeartLiens/${id}`
    } else if (+device_type === 6) {
      url = `user/familyUricAcids/${id}`
    } else {
      url = `user/familyHeartRates/${id}`
    }

    return http({
      url,
      method: 'delete'
    })
  },
  familyMeasuresPatch(data) {
    return http({
      url: `user/familyMeasures/${data.id}`,
      method: 'patch',
      data
    })
  },
  changeBasic(data) {
    return http({
      url: 'user/userDevice/changeBasic',
      method: 'post',
      data
    })
  },
  familyMeasureLatest(params) {
    return http({
      url: 'user/familyMeasure/latest',
      params
    })
  },

  familyTemperaturesPost(data) {
    return http({
      url: 'user/familyTemperatures',
      method: 'POST',
      data
    })
  },
  familyUricAcidsPost(data) {
    return http({
      url: 'user/familyUricAcids',
      method: 'POST',
      data
    })
  },
  familyBodyFatsPost(data) {
    return http({
      url: 'user/familyBodyFats',
      method: 'POST',
      data
    })
  },

  // 健康合伙人 是否购买了卡 是否有激活
  agentIsBuyCard({ withoutLogin }) {
    return http({
      url: 'user/agent/is_buy_card',
      withoutLogin
    })
  },
  // 发送短信验证码
  agentSendMsg() {
    return http({
      url: 'user/agent/send_msg',
      method: 'post'
    })
  },
  agentApplyPartner(data) {
    return http({
      url: 'user/agent/apply_partner',
      method: 'post',
      data
    })
  },

  familyBloodPressuresGraphData(params) {
    return http({
      url: 'user/familyBloodPressures/graphData',
      params
    })
  },

  familyBloodGlucosesGraphData(params) {
    return http({
      url: 'user/familyBloodGlucoses/graphData',
      params
    })
  },

  familyTemperatures(params) {
    return http({
      url: 'user/familyTemperatures',
      params
    })
  },

  familyBodyFats(params) {
    return http({
      url: 'user/familyBodyFats',
      params
    })
  },

  familyTemperaturesPatch(data) {
    return http({
      url: `user/familyTemperatures/${data.id}`,
      method: 'PATCH',
      data
    })
  },

  familyBodyFatsPatch(data) {
    return http({
      url: `user/familyBodyFats/${data.id}`,
      method: 'PATCH',
      data
    })
  },

  familyTemperatureLatest(params) {
    return http({
      url: 'user/familyTemperature/latest',
      params
    })
  },

  familyBodyFatLatest(params) {
    return http({
      url: 'user/familyBodyFat/latest',
      params
    })
  },
  /* 以下为邀请有礼相关接口 */
  inviteNotifications() {
    return http({
      url: 'user/invite/notifications',
      prefix: 'auth/api/'
    })
  },
  inviteSummary() {
    return http({
      url: 'user/invite/summary',
      prefix: 'auth/api/'
    })
  },
  inviteIndex() {
    return http({
      url: 'user/invite/index',
      prefix: 'auth/api/'
    })
  },
  familyHeightLatest(params) {
    return http({
      url: 'user/familyHeight/latest',
      params
    })
  },
  familyHeartRates(params) {
    return http({
      url: 'user/familyHeartRates',
      params
    })
  },
  familyHeartRatesLiEn(params) {
    return http({
      url: 'user/familyHeartLiens',
      params
    })
  },
  //全部心电折线图
  familyHeartMeasures(params) {
    return http({
      url: 'user/familyHeartMeasures',
      params
    })
  },
  //判断是否最后一次
  latest(params) {
    console.log(params, 'params')
    return http({
      url: 'user/familyHeartLien/latest',
      params
    })
  },
  familyHeartRatesPatch(data) {
    return http({
      url: `user/familyHeartRates/${data.id}`,
      data,
      method: 'PATCH'
    })
  },

  inviteBinds() {
    return http({
      url: 'user/inviteBinds',
      withoutLogin: true
    })
  },
  inviteBindHidden(id) {
    return http({
      url: `user/inviteBind/hidden/${id}`,
      method: 'POST'
    })
  },

  // 家庭档案群成员
  userBasics() {
    return http({
      url: 'user/basics'
    })
  },

  // 健康监测详情数据页
  adsArticles(params) {
    return http({
      url: 'user/ads/articles',
      params
    })
  },
  adsDoctors(params) {
    return http({
      url: 'user/ads/doctors',
      params
    })
  },
  adsDoctor(params) {
    return http({
      url: 'user/ads/suggestDoctors',
      params
    })
  },
  familyMeasureLogs(data) {
    return http({
      url: 'user/familyMeasureLogs',
      data,
      method: 'POST'
    })
  },

  // 获取消息列表
  getMessageList() {
    return http({
      url: 'message_center/message_list' + `?t=${new Date().getTime()}`,
      withoutLogin: true
    })
  },
  // 标记消息已读
  markMessageRead(params) {
    return http({
      url: 'message_center/show_message',
      params
    })
  },
  clearSearchHistory() {
    return http({
      baseURL: ENV_URL_PREFIX.daishu,
      url: 'wechat/api/clearHistory',
      prefix: ''
    })
  },
  select_card(params) {
    return http({
      url: 'user/card/select_card',
      params
    })
  },
  exchange_confirm(data) {
    return http({
      url: 'user/card/exchange_card',
      method: 'POST',
      data
    })
  },
  //获取用户心电设备类型
  getUserDevice() {
    return http({
      url: 'user/userDevice/heartTypes'
    })
  },
  familyUricAcid(params) {
    return http({
      url: 'user/familyUricAcid/latest',
      params
    })
  },
  familyUricAcids(params) {
    return http({
      url: 'user/familyUricAcids',
      params
    })
  },
  familyUricAcidsPatch(data) {
    return http({
      url: `user/familyUricAcids/${data.id}`,
      method: 'PATCH',
      data
    })
  }
}
export default user
